export const churches = [
    {
        island: "Jamaica",
        churches: [
            "Kingston SDA Church",
            "Spanish Town SDA Church",
            "Mandeville SDA Church",
            "Montego Bay SDA Church",
            "Port Antonio SDA Church",
            "May Pen SDA Church",
            "Linstead SDA Church",
            "Falmouth SDA Church",
            "Savanna-la-Mar SDA Church",
            "Ocho Rios SDA Church",
            "Negril SDA Church",
            "Black River SDA Church"
        ]
    },
    {
        island: "Trinidad and Tobago",
        churches: [
            "Port of Spain SDA Church",
            "San Fernando SDA Church",
            "Chaguanas SDA Church",
            "Arima SDA Church",
            "Point Fortin SDA Church",
            "Princes Town SDA Church",
            "Tunapuna SDA Church",
            "Scarborough SDA Church (Tobago)",
            "Crown Point SDA Church (Tobago)",
            "Marabella SDA Church",
            "Sangre Grande SDA Church"
        ]
    },
    {
        island: "Barbados",
        churches: [
            "Bridgetown SDA Church",
            "Speightstown SDA Church",
            "Oistins SDA Church",
            "Black Rock SDA Church",
            "Sam Lord's Castle SDA Church",
            "Holetown SDA Church",
            "Six Cross Roads SDA Church",
            "Cave Hill SDA Church"
        ]
    },
    {
        island: "Guyana",
        churches: [
            "Georgetown SDA Church",
            "New Amsterdam SDA Church",
            "Linden SDA Church",
            "Bartica SDA Church",
            "Anna Regina SDA Church",
            "Skeldon SDA Church",
            "Mahdia SDA Church",
            "Lethem SDA Church"
        ]
    },
    {
        island: "Bahamas",
        churches: [
            "Nassau SDA Church",
            "Freeport SDA Church",
            "Eleuthera SDA Church",
            "Exuma SDA Church",
            "Abaco SDA Church",
            "Andros SDA Church",
            "Long Island SDA Church",
            "Bimini SDA Church"
        ]
    },
    {
        island: "St. Lucia",
        churches: [
            "Castries SDA Church",
            "Vieux Fort SDA Church",
            "Soufriere SDA Church",
            "Dennery SDA Church",
            "Micoud SDA Church",
            "Gros Islet SDA Church"
        ]
    },
    {
        island: "Grenada",
        churches: [
            "St. George's SDA Church",
            "Grenville SDA Church",
            "Gouyave SDA Church",
            "Sauteurs SDA Church",
            "Carriacou SDA Church"
        ]
    },
    {
        island: "St. Vincent and the Grenadines",
        churches: [
            "Kingstown SDA Church",
            "Georgetown SDA Church",
            "Chateaubelair SDA Church",
            "Calliaqua SDA Church",
            "Bequia SDA Church",
            "Union Island SDA Church"
        ]
    },
    {
        island: "Dominica",
        churches: [
            "Antioch SDA Church - Portsmouth",
            "Bataca SDA Church - Salybia Kalinago Territory",
            "Bense SDA Church - Bense",
            "Beryl SDA Church - Gommier Road, Thibaud",
            "Bethel SDA Church - 10th Street, Canefield",
            "Boetica SDA Church - Boetica Village",
            "Bourne SDA Church - Dos D' Ane",
            "Calibishie SDA Church - Calibishie",
            "Capuchin SDA Church - Capuchin",
            "Castle Bruce SDA Church - Castle Bruce",
            "Dublanc SDA Church - Dublanc",
            "El Shaddai SDA Church",
            "La Plaine SDA Church - La Plaine",
            "Laudat SDA Group - Laudat Village, St. George",
            "Layou SDA Church - Layou",
            "Lily of the Valley SDA Church - Trafalgar Village, St. George",
            "Mahaut River SDA Church - Mahaut River, Kalinago Territory",
            "Mahaut SDA Church - Backstreet, Mahaut",
            "Marigot SDA Church - Marigot",
            "Mount Carmel SDA Church - Sansauver",
            "Mount Sinai SDA Church",
            "Penville SDA Church - Penville",
            "Pointe Michel SDA Church - Pointe Michel",
            "Portsmouth SDA Church - Portsmouth",
            "Riviere Cyrique SDA Church - Riviere Cyrique Village",
            "Roseau SDA Church - 1 Goodwill Road, Roseau",
            "Salisbury SDA Church - Salisbury",
            "St. Joseph SDA Church - St. Joseph",
            "Tarreau SDA Church - Tarreau",
            "Warner SDA Church - Warner",
            "Wesley SDA Church - Wesley",
            "Woodford Hill SDA Church - Woodford Hill"
        ]
    },
    {
        island: "Antigua and Barbuda",
        churches: [
            "St. John's SDA Church",
            "All Saints SDA Church",
            "Falmouth SDA Church",
            "Liberta SDA Church",
            "Barbuda SDA Church"
        ]
    },
    {
        island: "St. Kitts and Nevis",
        churches: [
            "Basseterre SDA Church",
            "Sandy Point SDA Church",
            "Charlestown SDA Church (Nevis)",
            "Gingerland SDA Church (Nevis)"
        ]
    },
    {
        island: "Martinique",
        churches: [
            "Fort-de-France SDA Church",
            "Le Lamentin SDA Church",
            "Schoelcher SDA Church",
            "Le Robert SDA Church"
        ]
    },
    {
        island: "Guadeloupe",
        churches: [
            "Pointe-à-Pitre SDA Church",
            "Basse-Terre SDA Church",
            "Les Abymes SDA Church",
            "Le Gosier SDA Church"
        ]
    },
    {
        island: "Belize",
        churches: [
            "Belize City SDA Church",
            "Belmopan SDA Church",
            "Orange Walk SDA Church",
            "San Ignacio SDA Church",
            "Dangriga SDA Church",
            "Punta Gorda SDA Church"
        ]
    },
    {
        island: "Suriname",
        churches: [
            "Paramaribo SDA Church",
            "Nieuw Nickerie SDA Church",
            "Moengo SDA Church",
            "Albina SDA Church"
        ]
    },
    {
        island: "Cayman Islands",
        churches: [
            "George Town SDA Church",
            "West Bay SDA Church",
            "Bodden Town SDA Church",
            "Cayman Brac SDA Church"
        ]
    },
    {
        island: "Turks and Caicos",
        churches: [
            "Providenciales SDA Church",
            "Grand Turk SDA Church",
            "North Caicos SDA Church"
        ]
    }
];
